export default function auth ({ next}){
    let user = JSON.parse(localStorage.getItem("user"));
    if(user==null){
        return next({
            name: 'login'
        })
    }else{
        if (user.type_compte!=="suntechdev")
        {
            return next({
                name: 'Home'
            })

        }else{
            return next();
        }
    }

}